<div class="siffi-language-picker"
	[class.siffi-language-picker--compact]="compact"
	(mouseenter)="open()"
	(mouseleave)="scheduleHoverClose()">
	<button
		#trigger
		id="selectedLangMenu"
		type="button"
		class="siffi-language-picker__trigger"
		(click)="toggle($event)"
		[attr.aria-expanded]="isOpen"
		aria-haspopup="menu">
		<img class="siffi-language-picker__flag" [src]="getFlagUrl(currentLanguage.icon)" [alt]="currentLanguage.nativeName">
		<span class="siffi-language-picker__caret" aria-hidden="true">&#9662;</span>
	</button>

	<div
		#popup
		class="siffi-language-picker__popup"
		[class.siffi-language-picker__popup--open]="isOpen"
		(mouseenter)="cancelHoverClose()"
		(mouseleave)="scheduleHoverClose()">
		<button
			*ngFor="let language of selectableLanguages; let index = index; trackBy: trackByLocale"
			id="selectLang{{index}}"
			type="button"
			class="siffi-language-picker__item"
			(click)="selectLanguage(language)">
			<img class="siffi-language-picker__item-flag" [src]="getFlagUrl(language.icon)" [alt]="language.nativeName">
			<span>{{ language.nativeName }}</span>
		</button>
	</div>
</div>
